<div class="btn">
  <img
    appImgFallback
    class="img"
    width="250"
    height="250"
    alt=""
    [src]="productCardAvatar()"
  />
</div>
